/**
*	@author Camilo
*	@since  01/11/2017
**/
export class PrefijoModel{

	constructor(
		public id:MchPrefijosId,
		public defTiposprefijos:DefTiposprefijos, 
		public nnuminicio:number, 
		public paramFormatos:ParamFormatos, 
		public paramDetallefactura:ParamDetallefactura, 
		public paramNegocios:ParamNegocios,
		public vformpago:string, 
		public vtexto1:string,
		public vtexto2:string,
		public vtexto3:string,
		public vtexto4:string,
		public vtexto5:string,
		public vtexto6:string,
		public cdescripcion:string,
		public ndiasvenc:number,
		public cprefijohomologo,
		public bloquear:any,
		public nmandatario:any,
		public ncontabiliza:any,
		public ncodigopago:number
		){}
}

export class MchPrefijosId{
	constructor(public cnumcont:string, public cprefijo:string, public ntipoempresa:number){}
}

export class DefTiposprefijos{
	constructor(public ntipodoc:string){}
}

export class ParamFormatos{
	constructor(public nidformato:string){}
}

export class ParamDetallefactura{
	constructor(public ndetallefact:string){}
}

export class ParamNegocios{
	constructor(public id:ParamNegociosId){}
}

export class ParamNegociosId{
	constructor(public cnumcont:string, public ntipoempresa:number){}
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Prefijo/Prefijo.model.ts